import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getWorkflowConfig = (id: string) => {
  return useApi(http.get(`/workflow/${id}`))
}

export const getAllWorkflows = () => {
  return useApi(http.get(`/workflows`))
}

export const createWorkflow = (data: any) => {
  return useApi(http.post(`/workflows`, data))
}

export const updateWorkflow = (id: string, data: any) => {
  return useApi(http.patch(`/workflows/${id}`, data))
}

export const deleteWorkflow = (id: string) => {
  return useApi(http.delete(`/workflows/${id}`))
}

export const createTransition = (data: any) => {
  return useApi(http.post(`/transitions`, data))
}

export const updateTransition = (id: string, data: any) => {
  return useApi(http.patch(`/transitions/${id}`, data))
}

export const deleteTransition = (id: string) => {
  return useApi(http.delete(`/transitions/${id}`))
}
